import { getMessages } from '../../../../../../../store/constants';

export const POLL_QUESTION_AGREE = getMessages().getText('poll.question.agree');
export const POLL_QUESTION_DISAGREE = getMessages().getText('poll.question.disagree');
export const POLL_QUESTION_GOOD = getMessages().getText('poll.question.good');
export const POLL_QUESTION_BAD = getMessages().getText('poll.question.bad');
